import React from "react";
import Builder from "../Builder/Builder";
import LearningPlanBuilderSidebar from "./LearningPlanBuilderSidebar";
import LearningPlanBuilderWorkspace from "./LearningPlanBuilderWorkspace";
import { DragDropContext } from "react-beautiful-dnd";
import DisappearingSuccess from "../Notifications/DisappearingSuccess";

export default class LearningPlanBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.learnable_items = [
      {
        id: "course",
        learnable_type: "Course",
        name: `${I18n.t("admin.learning_plan.name")} ${I18n.t("admin.course")}`,
        icon: "fa-book",
      },
      {
        id: "exam",
        learnable_type: "Exam",
        name: `${I18n.t("admin.learning_plan.name")} ${I18n.t("admin.exam")}`,
        icon: "fa-graduation-cap",
      },
    ];

    this.state = {
      errors: [],
      success: null,

      learning_plan_id: window.location.href.substring(
        window.location.href.lastIndexOf("/") + 1
      ),

      name: "",
      auto_enroll: false,
      sequential: true,
      description: "",

      items: [],
      loading: false,
      settingsExpanded: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeItem = this.onChangeItem.bind(this);
    this.onAddItem = this.onAddItem.bind(this);
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this.onExpandCollapseItem = this.onExpandCollapseItem.bind(this);
    this.onExpandCollapseSettings = this.onExpandCollapseSettings.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onHideSuccess = this.onHideSuccess.bind(this);
    this.onSaveLearningPlan = this.onSaveLearningPlan.bind(this);
  }

  componentDidMount() {
    if (this.isEditingExistingLearningPlan()) {
      this.onLoadLearningPlan();
    }
  }

  render() {
    return (
      <div className="LearningPlanBuilder">
        {this.state.success ? (
          <DisappearingSuccess onHide={this.onHideSuccess}>
            {this.state.success}
          </DisappearingSuccess>
        ) : null}
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Builder
            onSave={this.onSaveLearningPlan}
            title={
              this.state.name && this.state.name !== ""
                ? this.state.name
                : I18n.t("admin.new_learning_plan")
            }
            sidebar={
              <LearningPlanBuilderSidebar
                items={this.learnable_items}
                onAddItem={this.onAddItem}
              />
            }
            backUrl={`/admin/${this.props.account.public_id}/learning-plans`}
            workspace={
              <LearningPlanBuilderWorkspace
                {...this.state}
                courses={this.props.courses}
                errors={this.state.errors}
                onChange={this.onChange}
                onChangeItem={this.onChangeItem}
                onRemoveItem={this.onRemoveItem}
                onExpandCollapseItem={this.onExpandCollapseItem}
                onExpandCollapseSettings={this.onExpandCollapseSettings}
              />
            }
          />
          {this.state.loading ? (
            <div className="loadingOverlay">
              <div className="spinner" />
            </div>
          ) : null}
        </DragDropContext>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onChangeItem(new_item) {
    const items = this.state.items.map((item) => {
      if (item.id === new_item.id) {
        return { ...new_item };
      } else {
        return { ...item };
      }
    });
    this.setState({ items: items });
  }

  onAddItem(added_item) {
    const { id } = added_item;
    const item = this.learnable_items.find((item) => item.id === id);
    this.addItem(item);
  }

  onRemoveItem(item_id) {
    this.setState({
      items: this.state.items.filter((item) => {
        return item.id !== item_id;
      }),
    });
  }

  onExpandCollapseItem(item_id) {
    const items = this.state.items.map((item) => {
      if (item.id === item_id) {
        return { ...item, expanded: !item.expanded };
      } else {
        return { ...item, expanded: false };
      }
    });
    this.setState({ items: items });
  }

  onExpandCollapseSettings() {
    const items = this.state.items.map((item) => {
      return { ...item, expanded: false };
    });
    this.setState({
      items: items,
      settingsExpanded: !this.state.settingsExpanded,
    });
  }

  onDragEnd(result) {
    const { source, destination, draggableId } = result;

    // dropped outside
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      // dropped into same list it started in - update order
      const items = this.reorder(
        this.state.items,
        source.index,
        destination.index
      );
      this.setState({ items: items });
    } else {
      // dropped into new list
      const item = this.learnable_items.find((item) => item.id === draggableId);
      this.addItem(item);
    }
  }

  onLoadLearningPlan() {
    this.setState({ loading: true }, () => {
      $.ajax({
        type: "POST",
        url: this.props.get_learning_plan_endpoint,
        data: { id: this.state.learning_plan_id },
      }).done((data) => {
        if (data.errors) {
          this.setState({ loading: false, errors: data.errors });
        } else {
          this.setState({
            loading: false,
            errors: [],
            name: data.name,
            description: data.description,
            auto_enroll: data.auto_enroll,
            sequential: data.sequential,
            items: this.postProcessLearningPlanItems(
              data.learning_plan_section && data.learning_plan_section[0]
                ? data.learning_plan_section[0].learning_plan_items
                : []
            ), // learning plans currently hard coded to a single section
          });
        }
      });
    });
  }

  onSaveLearningPlan() {
    this.setState({ loading: true }, () => {
      $.ajax({
        type: this.isEditingExistingLearningPlan() ? "PUT" : "POST",
        url: this.isEditingExistingLearningPlan()
          ? this.props.learning_plan_update_endpoint
          : this.props.learning_plan_create_endpoint,
        data: this.buildLearningPlanParams(),
      }).done((data) => {
        // console.log('onSaveLearningPlan done', data)
        if (data.errors) {
          this.setState({ loading: false, errors: data.errors, success: null });
        } else {
          this.setState(
            {
              errors: [],
              success: this.isEditingExistingLearningPlan()
                ? I18n.t("admin.learning_plan.success_update_learning_plan")
                : I18n.t("admin.learning_plan.success_new_learning_plan"),
              learning_plan_id: data.id,
              name: data.name,
              description: data.description,
              auto_enroll: data.auto_enroll,
              sequential: data.sequential,
              items: this.postProcessLearningPlanItems(
                data.learning_plan_section && data.learning_plan_section[0]
                  ? data.learning_plan_section[0].learning_plan_items
                  : []
              ),
            },
            this.generateTemplateIds
          );
        }
      });
    });
  }

  generateTemplateIds() {
    // console.log(
    //   "generateTemplateIds",
    //   this.props.generate_learning_plan_template_id_endpoint
    // );
    var error = false;
    for (var i = 0, ilen = this.state.items.length; i < ilen; i++) {
      const item = this.state.items[i];
      // console.log("item", item);
      $.ajax({
        type: "POST",
        url: this.props.generate_learning_plan_template_id_endpoint,
        data: { id: item.id },
        async: false,
      }).done((data) => {
        if (data && data.error) {
          // console.log("ERROR WITH ASSESSMENT API", data.error);
          error = data.error;
        }
      });
    }

    // console.log("done generatingTemplateIds", error);

    if (error) {
      this.setState({ errors: [error], success: null, loading: false });
    } else {
      this.setState({
        errors: [],
        loading: false,
        success: this.isEditingExistingLearningPlan()
          ? I18n.t("admin.learning_plan.success_update_learning_plan")
          : I18n.t("admin.learning_plan.success_new_learning_plan"),
      });
    }
  }

  /*
   * Helpers
   */

  addItem(item) {
    const items = this.state.items.map((item) => {
      return { ...item, expanded: false };
    });

    if (item.learnable_type === "Exam") {
      // preload course questions
      const course_questions = [];
      this.state.items.map((item) => {
        if (item.learnable_type === "Course" && item.learnable_id) {
          course_questions.push({
            course_id: item.learnable_id,
            number_of_questions: "",
          });
        }
      });
      this.setState({
        items: [
          ...items,
          {
            ...item,
            id: `${item.id}-${Date.now()}`,
            course_questions: course_questions,
            expanded: false,
          }, // or expanded: true if you want to expand the item when it's added
        ],
      });
    } else {
      this.setState({
        items: [
          ...items,
          { ...item, id: `${item.id}-${Date.now()}`, expanded: false }, // or expanded: true if you want to expand the item when it's added
        ],
      });
    }
  }

  buildLearningPlanParams() {
    const items = {};

    this.state.items.map((item, index) => {
      const { course_questions = [] } = item;
      if (item.learnable_type === "Exam") {
        items[index] = {
          id: item.id,
          learnable_type: "Exam",
          learnable_id: item.learnable_id,
          learnable_attributes: {
            name: item.name,
            locked: item.locked,
            score_released: item.score_released,
            passing_score:
              typeof item.passing_score !== "undefined"
                ? parseInt(item.passing_score)
                : 80,
            exam_courses_attributes: course_questions.map(
              (course_questions) => {
                return {
                  course_id: course_questions.course_id,
                  position: course_questions.position || index,
                  number_of_questions:
                    course_questions.number_of_questions || 1,
                  question_pool: course_questions.question_pool || "course",
                };
              }
            ),
          },
        };
      } else if (item.learnable_type === "Course") {
        items[index] = {
          id: item.id,
          learnable_type: "Course",
          learnable_id: item.learnable_id,
          learnable_attributes: {
            pretest: typeof item.pretest !== "undefined" ? item.pretest : false,
            posttest:
              typeof item.posttest !== "undefined" ? item.posttest : false,
            pretest_number_of_questions: item.pretest_number_of_questions || 1,
            posttest_number_of_questions:
              item.posttest_number_of_questions || 1,
            pretest_question_pool: item.pretest_question_pool || "course",
            posttest_question_pool: item.posttest_question_pool || "course",
            posttest_passing_score: item.posttest_passing_score || 80,
            passed_post_tests_for_completion:
              item.passed_post_tests_for_completion || 1,
          },
        };
      }
    });

    const lp_params = {
      account_id: this.props.account.public_id,
      api_key: this.props.account.api_key,
      id: this.state.learning_plan_id,
      learning_plan: {
        name:
          this.state.name && this.state.name !== ""
            ? this.state.name
            : "New Learning Plan " + new Date().valueOf(),
        auto_enroll: this.state.auto_enroll,
        sequential: this.state.sequential,
        description: this.state.description,
        learning_plan_sections_attributes: {
          0: {
            // hardcoded single section for now
            learning_plan_items_attributes: items,
          },
        },
      },
    };

    return lp_params;
  }

  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }

  isEditingExistingLearningPlan() {
    return this.state.learning_plan_id && this.state.learning_plan_id !== "new";
  }

  onHideSuccess() {
    this.setState({ success: null });
  }

  postProcessLearningPlanItems(items) {
    items = items.map((item) => {
      if (item.learnable_type === "Exam") {
        item.name = item.learnable.name;
        item.locked = item.learnable.locked;
        item.score_released = item.learnable.score_released;
        item.course_questions = item.learnable.exam_courses;
        item.passing_score = item.learnable.passing_score;
      }
      return item;
    });
    return items;
  }
}
